module.exports = __webpack_public_path__ + "img/change-card-2-2.svg";